import { useState } from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useAuth, login } from "../../context/AuthContext";

const LINKS = [
  ["/", "首頁"],
  ["/learn", "注音與文字學習"],
  ["/stories", "故事總覽"],
  ["/dashboard", "我的學習中心"],
  ["/pricing", "方案與價格"],
  ["/contact", "聯絡我們"],
];

const NavItems = ({ onClick }) =>
  LINKS.map(([to, label]) => (
    <NavLink key={to} to={to} end={to === "/"} onClick={onClick} data-testid={`site-nav-${to === "/" ? "home" : to.slice(1)}`}
      className={({ isActive }) => `px-4 py-2 rounded-full font-bold transition-colors ${isActive ? "bg-[var(--vermilion)] text-white" : "text-[var(--tea)] hover:bg-amber-100"}`}>
      {label}
    </NavLink>
  ));

export const SiteLayout = ({ children }) => {
  const { user } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const cta = user ? (
    <button data-testid="site-enter-btn" onClick={() => nav("/profiles")} className="kid-btn !min-h-[48px] px-6 bg-[var(--jade)] text-white">進入冒險</button>
  ) : (
    <button data-testid="site-login-btn" onClick={login} className="kid-btn !min-h-[48px] px-6 bg-[var(--vermilion)] text-white">家長登入</button>
  );
  return (
    <div className="min-h-screen paper-bg flex flex-col">
      <header className="sticky top-0 z-30 bg-[#FFF9EE]/90 backdrop-blur-md border-b-2 border-amber-200">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 h-20 flex items-center gap-6">
          <Link to="/" data-testid="site-logo" className="flex items-center gap-3 shrink-0">
            <span className="seal w-11 h-11 flex items-center justify-center font-brush text-2xl">書</span>
            <span className="font-serif-tc font-black text-2xl text-[var(--vermilion)]">小書童</span>
          </Link>
          <nav className="hidden lg:flex items-center gap-1 flex-1 justify-center font-serif-tc"><NavItems /></nav>
          <div className="hidden lg:block">{cta}</div>
          <button data-testid="site-menu-btn" className="lg:hidden ml-auto w-12 h-12 rounded-full bg-white border-2 border-[var(--line)] flex items-center justify-center" onClick={() => setOpen(!open)}>{open ? <X /> : <Menu />}</button>
        </div>
        {open && <nav className="lg:hidden flex flex-col gap-1 px-5 pb-4 font-serif-tc" data-testid="site-mobile-menu"><NavItems onClick={() => setOpen(false)} /><div className="pt-2">{cta}</div></nav>}
      </header>
      <main className="flex-1">{children}</main>
      <footer className="border-t-2 border-amber-200 bg-[#F4EBD9]">
        <div className="max-w-7xl mx-auto px-6 py-10 grid sm:grid-cols-3 gap-6 font-serif-tc text-[var(--tea)]">
          <div>
            <div className="font-black text-xl">小書童的古代大冒險</div>
            <p className="text-sm mt-2 text-stone-600">用故事學注音、學繁體字。</p>
          </div>
          <div className="flex flex-col gap-1 text-sm">{LINKS.map(([to, l]) => <Link key={to} to={to} className="hover:text-[var(--vermilion)]">{l}</Link>)}</div>
          <p className="text-sm text-stone-600">無廣告・無聊天室・不公開孩子資料。帳號由家長管理。<Link to="/staff/login" data-testid="footer-staff-link" className="block mt-2 text-xs text-stone-400 hover:text-[var(--vermilion)]">管理員登入</Link></p>
        </div>
      </footer>
    </div>
  );
};
